import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useChatAvailabilityQuery as useChatAvailabilityQueryType } from "@/modules/chats/services/__generated__/useChatAvailabilityQuery.graphql"

const chatAvailabilityQuery = graphql`
  query useChatAvailabilityQuery {
    chatAvailability {
      id
      language
      canCreateMedicalChats
      canCreateAdministrativeChats
    }
  }
`

const useChatAvailabilityQuery = () => {
  const data = useLazyLoadQuery<useChatAvailabilityQueryType>(
    chatAvailabilityQuery,
    {},
    { fetchPolicy: "store-and-network" },
  )

  return data
}

export { useChatAvailabilityQuery }
